import { useIntl } from "react-intl";

import { Avatar } from "@/components/Avatar/Avatar";
import { AvatarGroup } from "@/components/Avatar/AvatarGroup";

type Airline = {
  name: string;
  logoUrl: string;
};

type Props = {
  airlines: Airline[];
};

export function AirlineAvatarGroup({ airlines }: Props) {
  const intl = useIntl();

  return (
    <AvatarGroup>
      {airlines.map((airline) => (
        <Avatar
          key={airline.name}
          alt={intl.formatMessage(
            {
              defaultMessage: "{airline} logo",
              description: "Accessible alt text for an airline logo image",
            },
            { airline: airline.name },
          )}
          size="medium"
          src={airline.logoUrl}
          fallback={airline.name?.charAt(0) || ""}
        />
      ))}
    </AvatarGroup>
  );
}
